import React, { useEffect } from "react";

const Approvals = () => {
  // Scroll reveal effect
  useEffect(() => {
    const revealElements = document.querySelectorAll(".scroll-reveal");
    const handleScroll = () => {
      revealElements.forEach((el) => {
        const top = el.getBoundingClientRect().top;
        if (top < window.innerHeight - 50) {
          el.classList.add("revealed");
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="min-h-screen py-16 px-4 md:px-20"
      style={{ backgroundColor: "var(--bg-1)", color: "var(--brand-dark)" }}
    >
      <div className="container-custom">
        {/* Page Heading */}
        <h1
          className="text-4xl md:text-5xl font-bold mb-12 scroll-reveal text-center"
          style={{ transitionDelay: "0.2s" }}
        >
          Approvals & Legal
        </h1>

        {/* RERA Registration */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            RERA Registration
          </h2>
          <p className="text-lg leading-relaxed">
            All our projects are registered with the Real Estate Regulatory
            Authority (RERA), ensuring transparency, timely delivery, and
            compliance with legal requirements. Below are our project RERA
            numbers:
          </p>
          <ul className="list-disc sm:ml-4 ml-6 text-lg leading-relaxed mt-2">
            <li>Project A - RERA Number: AP/123/2025</li>
            <li>Project B - RERA Number: AP/456/2025</li>
            <li>Project C - RERA Number: AP/789/2025</li>
          </ul>
        </section>

        {/* VMRDA Approvals */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            VMRDA Approvals
          </h2>
          <p className="text-lg leading-relaxed">
            Our projects comply with Visakhapatnam Metropolitan Region
            Development Authority (VMRDA) regulations. This includes
            environmental clearances, layout approvals, and building permits to
            ensure safe and legal construction.
          </p>
        </section>

        {/* Legal Documents */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Legal Documents
          </h2>
          <p className="text-lg leading-relaxed">
            We maintain all the legal documents for our properties, including:
          </p>
          <ul className="list-disc sm:ml-4 ml-6 text-lg leading-relaxed mt-2">
            <li>Title Deeds and Ownership Certificates</li>
            <li>Building Plan Approvals</li>
            <li>No Objection Certificates (NOCs) from relevant authorities</li>
            <li>Sale Agreements and Registrations</li>
          </ul>
        </section>

        {/* Compliance & Safety */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Compliance & Safety
          </h2>
          <p className="text-lg leading-relaxed">
            DVV Projects ensures compliance with all statutory and environmental
            regulations. Safety audits are conducted periodically to maintain
            high standards in construction quality and living conditions.
          </p>
        </section>

        {/* Disclaimer */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Disclaimer
          </h2>
          <p className="text-lg leading-relaxed">
            While we strive to provide accurate project approvals and legal
            information, all content is provided "as is". DVV Projects does not
            guarantee the completeness, reliability, or accuracy of any
            information.
          </p>
        </section>

        {/* Limitation of Liability */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Limitation of Liability
          </h2>
          <p className="text-lg leading-relaxed">
            DVV Projects shall not be liable for any damages arising from the
            use of this information or reliance on any legal or approval
            documents, including direct, indirect, incidental, or consequential
            damages.
          </p>
        </section>

        {/* Contact for Legal Queries */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Contact Us
          </h2>
          <p className="text-lg leading-relaxed">
            For any legal queries, document verification, or project approvals,
            contact our legal team:
          </p>
          <ul className="mt-2 text-lg">
            <li>
              <strong>Phone:</strong>{" "}
              <span className="text-brand-gold">+91 7288080999</span>
            </li>
            <li>
              <strong>Email:</strong>{" "}
              <span className="text-brand-gold font-semibold">
                info@dvvprojects.com
              </span>
            </li>
            <li>
              <strong>Address:</strong>
              <div className="text-brand-gold mt-1 break-words">
  <strong>Head Office:</strong><br />
  2nd Floor, 28-18-9, Timpany School Road,<br />
  Opposite Indian Overseas Bank, Vuda Colony,<br />
  Gonthinavanipalem, Gajuwaka,<br />
  Visakhapatnam, Andhra Pradesh 530026
  <br /><br />

  <strong>Branch Office:</strong><br />
  D.No 49-49-6, First Floor,<br />
  Beside Arka Hospital, Santhipuram,<br />
  Akkayyapalem,<br />
  Visakhapatnam, Andhra Pradesh 530016
</div>
            </li>
          </ul>
        </section>

        {/* Last Updated */}
        <section className="mb-12 scroll-reveal">
          <p className="text-lg text-gray-600 italic">
            Last updated: 22 December 2025
          </p>
        </section>
      </div>
    </div>
  );
};

export default Approvals;
